export default "__VITE_ASSET__16d6f71a__"